module.exports = "/* background-color: #31b189;  بیشتر */\r\n/* background-color: #7ace67;  ;ljv */"